import { render, staticRenderFns } from "./SelectableImage.vue?vue&type=template&id=9cfc4f60&scoped=true"
import script from "./SelectableImage.vue?vue&type=script&lang=js"
export * from "./SelectableImage.vue?vue&type=script&lang=js"
import style0 from "./SelectableImage.vue?vue&type=style&index=0&id=9cfc4f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfc4f60",
  null
  
)

export default component.exports